export default __webpack_public_path__ + "static/media/cxeerss.83a0ab49.svg";